import React from 'react';

/**
 * Resize handle component for resizable panels
 * @param {Object} props Component props
 * @param {Function} props.onMouseDown Handler for mouse down event
 * @param {string} props.direction Direction of resize ('horizontal' or 'vertical')
 * @returns {React.ReactElement} ResizeHandle component
 */
const ResizeHandle = ({ onMouseDown, direction }) => {
  const handleClass = direction === 'horizontal' ? 'resize-handle-horizontal' : 'resize-handle-vertical';
  
  return (
    <div 
      className={`resize-handle ${handleClass}`}
      onMouseDown={onMouseDown}
    />
  );
};

export default ResizeHandle; 